<div class="loader-overlay" *ngIf="show">
  <div>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  </div>
</div>
